import { countBy } from 'lodash'

const defaultBrowserTitle = '满帮CRM'

/**
 * 将总未读数通知到浏览器标签标题
 * @param userList
 * @param count
 * @param recover
 */
export function countUnReadPostBrowser(userList, count = 0, recover = false) {
  if (recover) {
    document.title = defaultBrowserTitle
    return
  }
  if (Array.isArray(userList)) {
    count = userList.reduce((memo, item) => {
      return memo + item.unReadMsgNum
    }, count)
  }
  // 0未读不展示
  document.title = (count ? `【${count}未读】` : '') + defaultBrowserTitle
}
